var _Path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { G, Path } from "react-native-svg";

function SvgIconBuildWhite(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 32 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement(G, {
    stroke: props.fill,
    strokeWidth: 1.08,
    fill: "none",
    fillRule: "evenodd"
  }, _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    d: "M11.533 11.637h8.934M11.533 7.276h8.934M4.987 16.575c0 .713.587 1.293 1.31 1.293h3.927c.723 0 1.31-.58 1.31-1.293V2.353c0-.714-.587-1.293-1.31-1.293H6.297c-.723 0-1.31.579-1.31 1.293v14.222zM1.06 12.696c0 .714.587 1.293 1.31 1.293h2.617v-9.05H2.37c-.722 0-1.309.578-1.309 1.293v6.464zM27.013 16.575c0 .713-.587 1.293-1.31 1.293h-3.927c-.723 0-1.31-.58-1.31-1.293V2.353c0-.714.587-1.293 1.31-1.293h3.927c.723 0 1.31.579 1.31 1.293v14.222zM30.94 12.696c0 .714-.587 1.293-1.31 1.293h-2.617v-9.05h2.618c.722 0 1.309.578 1.309 1.293v6.464z"
  }))));
}

export default SvgIconBuildWhite;